import React ,{createContext, useState, useEffect, useContext} from 'react'

const ResultContext= createContext();
const baseURL = 'https://google-search3.p.rapidapi.com/api/v1'

export const ResultContextProvider = ({ children }) =>{
    const[results, setResults] = useState([]);
    const[isLoading, setIsLoading]= useState(false)
    const[searchWord, setSearchWord] = useState('Walmart Stores')

    // since we make api calls here, creating getResults() as async func

    // type means /search , /videos, /images and so on
    const getResults = async (type) =>{
        setIsLoading(true);

        const response = await fetch(`${baseURL}${type}`,{
         method:'GET',
         headers:{
            'x-user-agent': 'desktop',
            'x-proxy-location': 'US',
            'x-rapidapi-host': 'google-search3.p.rapidapi.com',
            'x-rapidapi-key': process.env.REACT_APP_API_KEY,
         }
        });

        const data = await response.json();

        console.log(data);
        console.log({type, data})

        if(type.includes('/news')){
            setResults(data.entries);
        }
        else if(type.includes('/images')){
            setResults(data.image_results);}

         else {setResults(data.results); }  

        // setResults(data);
        setIsLoading(false)


    }
    return (
        <ResultContext.Provider value={{getResults,results,searchWord,setSearchWord,isLoading,setIsLoading}}>
            {children}
        </ResultContext.Provider>
    )
}

export const useResultContext= () => useContext(ResultContext);
